// extracted by mini-css-extract-plugin
export default {"root":"Search_root__eiX89","icon":"Search_icon__XMmYc","input":"Search_input__klILD","isHighlighted":"Search_isHighlighted__1G8Cm","Drop":"Search_Drop__Ii0mz"};